export default import.meta.ROLLDOWN_FILE_URL_GwA1sUmkflmVM_q25Qqydw